import {
  Component,
  ElementRef,
  NgZone,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
// import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';

import {
  AppSelectionOptions,
  LaunchNavigator,
  LaunchNavigatorOptions,
  RememberChoiceOptions,
} from '@awesome-cordova-plugins/launch-navigator/ngx';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';
import { PhotoViewer } from '@awesome-cordova-plugins/photo-viewer/ngx';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  PopoverController,
  ToastController,
} from '@ionic/angular';
import { AddReviewsPage } from '../add-reviews/add-reviews.page';
import { CartPage } from '../cart/cart.page';
import { GlobalVariable } from '../global';
import { MenuPage } from '../menu/menu.page';
import { MyBusinessesPage } from '../my-businesses/my-businesses.page';
import { OrderSettingsPage } from '../order-settings/order-settings.page';
import { PhotoViewerPage } from '../photo-viewer/photo-viewer.page';
import { ServerService } from '../providers/server.service';
import { ShowUserReviewsPage } from '../show-user-reviews/show-user-reviews.page';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';

declare var google;
@Component({
  selector: 'app-business-details',
  templateUrl: './business-details.page.html',
  styleUrls: ['./business-details.page.scss'],
})
export class BusinessDetailsPage {
  @ViewChild('map') mapElement: ElementRef;
  cartObjectQuantity: number;
  subtotal: number;
  index: any;
  isexist: boolean;
  time: number;
  day: number;
  date: Date;
  type: string;
  DataFlag: boolean;
  paypal: any;
  heading: any;
  price: any;
  NAME: any;
  name: any;
  business_id: any;
  id: any;
  currentId: any;
  PageFlag: void;

  cartflag: boolean;
  category = [];
  super_category = [];
  activeSegment = 'menu';
  contacts: any;
  isShowSubMenu: boolean;
  myChoice: any[] = new Array();
  data: any;
  map: any;
  geocoder = new google.maps.Geocoder();
  longitude: number = 0;
  latitude: number = 0;
  shownGroup = null;
  quantity_value: any = 1;
  coordinates: any;
  places: any;
  keyword: any;
  forsearch: any;
  s_day: any;
  s_time: any;
  categories_section: any = 'Regular';
  branchId: any;
  businessData: any;
  newId: any;
  nID: any;
  service = new google.maps.places.AutocompleteService();
  addressSearch: boolean = false;
  geo: any;
  temp: boolean = true;
  autocompleteItems: any;
  autocomplete: any;
  menuitems: any;
  Randomcolor;
  order_pickup = this.globals.pickup;
  order_delivery = this.globals.delivery;
  pickupTime: string;
  categoryTop: any;
  Topitem1: any;
  Topitem2: any;
  myFavorites: Object[] = [];
  isFavorite: boolean = false;
  inFavList: boolean = false;
  deliveryAdress: string = '';
  reviewData = [];
  details: any;
  promotedItems = [];
  ShareLinkURL: string;
  branchUniversalObj = null;
  resAddress: any;
  dataNotLoaded = true;
  isVerified = false;
  reviewId: any;
  placeName: any;
  cuisinesOfBusiness;
  showhours = true;
  uniqueId: any;
  isOpenMenu: any;
  averageRating = 0;
  discoveredBy: any;
  openReviewPage: any;
  // limitOfReviews=5;

  constructor(
    private geolocation: Geolocation,
    public server: ServerService,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    private nativeStorage: NativeStorage,
    private toastCtrl: ToastController,
    public globals: GlobalVariable,
    // public http: Http,
    public navCtrl: NavController,
    // public navParams: NavParams,
    public modalCtrl: ModalController,
    public zone: NgZone,
    public popoverCtrl: PopoverController,
    public socialShare: SocialSharing,
    // private branch: BranchIo,
    public platform: Platform,
    private callTo:CallNumber,
    private launchNavigator: LaunchNavigator,
    private photoViewer: PhotoViewer,
    public route: ActivatedRoute,
    public router: Router
  ) {
    this.autocompleteItems = [];
    this.autocomplete = {
      query: '',
    };
    this.globals.checkGPSPermission();

    if (!this.globals.address) {
      this.getLocation();
    }
    // this.uniqueId=this.navParams.get('uniqueid')
    // this.route.queryParams.subscribe(_p => {
    this.uniqueId = this.router.getCurrentNavigation().extras?.state?.uniqueid;
    this.openReviewPage = this.router.getCurrentNavigation().extras?.state?.openReviewPage;
    console.log('id fromurl ', this.uniqueId);
    if (this.route.snapshot.params) {
      // this.businessDetail = this.route.snapshot.data;
      // console.log('data',this.businessDetail)
      console.log('username', this.route.snapshot.params['name']);
      let id = this.route.snapshot.params['name'];
      if (this.globals.address) {
        this.list(id);
      }
      console.log('item', this.route.snapshot.params['item']);
      // this.isOpenMenu=this.route.snapshot.params['item']
    }
    // if(this.uniqueId){
    //   this.list()

    // }

    // if (navParams) {
    // this.businessData = navParams.businessData;
    // this.uniqueId=navParams.uniqueid
    // }
    // })

    // // setup business for usage in app - part of new halal guide app
    // this.businessData = this.navParams.get("businessData");
    // this.globals.activeBusinessData = this.businessData;
    // console.log(this.businessData);
    // this.name = this.businessData.name;
    // let long = parseFloat(this.businessData.longitude);
    // let lat = parseFloat(this.businessData.latitude);
    // this.longitude = long;
    // this.latitude = lat;

    //returning from reviewpage
    this.newId = this.router.getCurrentNavigation().extras?.state?.sendBackId;

    // this.newId = this.navParams.get("sendBackId");

    // console.log(this.newId)
    // if (this.businessData != undefined) {
    //   this.nID = this.businessData.business_id;
    // }

    // if (this.newId != undefined) {
    //   this.nID = this.newId;
    // }
    // this.businessData = this.router.getCurrentNavigation().extras?.state?.businessData
    console.log('navvv...........', this.businessData);

    // if (this.businessData) {
    //   this.globals.setupBusiness(this.businessData);
    // }
    this.cartflag = this.router.getCurrentNavigation().extras.state?.CartFlag;
    this.PageFlag = this.router.getCurrentNavigation().extras.state?.pageflag;
    // if (!this.globals.caos_flag) {
    //   console.log("Modal call from category");
    //   if (this.globals.branch_enabled == 1) {
    //     this.branchId = this.globals.bussinessId;
    //   }

    //   this.presentModal(0);
    // } else {
    //   this.globals.OrderType = "pickup";
    // }

    // this.cartflag = this.navParams.get("CartFlag");
    // this.PageFlag = this.navParams.get("pageflag");
    // this.business_id = this.globals.bussinessId;

    // if (!this.globals.caos_flag) {
    //   this.getLocation();
    // }

    // this.myChoice.push("abcd");
    // this.myChoice.pop();

    // this.Categories();
    // let url = 'https://demo.mikronexus.net/#/category?bID=';
    // let params = (new URL(url)).searchParams;
    // params.get('bID')
  }

  // ngOnInit() {
  //   // this.route.queryParams.subscribe(_p => {
  //   //   const navParams = this.router.getCurrentNavigation().extras.state
  //   //   console.log('nav params',navParams);
  //   //   if (navParams) {
  //   //     this.businessData = navParams.businessData;
  //   //     this.uniqueId=navParams.uniqueid
  //   //   }
  //   // })

  // }

  ionViewWillEnter() {}
  back() {
    this.navCtrl.navigateBack('/home');
    // this.router.
  }
  ionViewDidEnter() {
    // this.Categories();
  }
  ionViewWillLeave() {
    this.globals.dataNotLoaded = true;
  }
  async gotoCart() {
    // let popover = await this.popoverCtrl.create({
    //   component:CartPage,
    //   cssClass:'cartPOP',
    //   showBackdrop:true,
    //   backdropDismiss:true,
    //   side:'right',
    //   animated:true,
    //   mode:'ios',
    //   arrow:true,
    // })
    // popover.present();
    this.navCtrl.navigateForward('cart');
  }
  getType() {
    this.deliveryAdress = localStorage.getItem('GetAddress');
    if (!this.globals.OrderType) {
      if (this.order_pickup && !this.order_delivery) {
        this.type = 'pickup';
        this.globals.OrderType = this.type;
      } else if (this.order_delivery) {
        this.type = 'delivery';
        this.globals.OrderType = this.type;
      }
    } else {
      this.type = this.globals.OrderType;
    }
  }
  reverseGeoCoding() {
    let response = this.server.getAddress(this.globals.mycoordinates);
    var myadress = '';
    response.subscribe(
      (data) => {
        console.log('data from adrress api ', data);
        myadress = data.address;
        this.globals.address = myadress;
      },
      (error) => {
        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
  }
  numberChange(phone: string) {
    // console.log('here')
    // this.formatedPhone = String(phone;
    if (phone) {
      if (phone.includes('+', 0)) {
        // console.log('include +');
        phone = phone.slice(2);
        // console.log(phone)
      }
    }

    var cleaned = ('' + phone).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      return (
        '(' + match[1] + ') ' + (match[2] ? match[2] + '-' : '') + match[3]
      );
      // console.log(this.formatedPhone)
    }
    // var match = cleaned.match( /^(\d{3})(\d{3})(\d{4})$/)
    // if (match) {

    //     console.log('match')
    //   this.formatedPhone= '(' + match[1] + ') ' + match[2] + '-' + match[3]
    // }
    return null;
    // var clean = this.formatedPhone.replace(/[^\d]/g, '')
    // console.log(clean)
    // this.formatedPhone = clean.replace(/[0-9]{3}-[0-9]{3}-[0-9]{4}/g,'');
    // console.log(this.formatedPhone)
  }
  // menu tabs  starts from here
  openMenuTab() {
    //         var btnContainer = document.getElementById("tabs_menu");

    // // Get all buttons with class="btn" inside the container
    // var btns = btnContainer.getElementsByClassName("menu_item");

    // // Loop through the buttons and add the active class to the current/clicked button
    // for (var i = 0; i < btns.length; i++) {
    //   btns[i].addEventListener("click", function() {
    //     var current = document.getElementsByClassName("active");

    //     // If there's no active class
    //     if (current.length > 0) {
    //       current[0].className = current[0].className.replace(" active", "");
    //     }

    //     // Add the active class to the current/clicked button
    //     this.className += " active";
    //   });
    // }
    var btnContainer = document.getElementById('tabs_menu');

    // Get all buttons with class="btn" inside the container
    var btns = btnContainer.getElementsByClassName('menu_item');

    // Loop through the buttons and add the active class to the current/clicked button
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        var current = document.getElementsByClassName('active');
        console.log(current);

        current[0].className = current[0].className.replace(' active', '');
        this.className += ' active';
      });
    }
    // document.getElementById('menu').
    document.getElementById('menu').scrollIntoView({ behavior: 'smooth' });
  }
  openAboutTab() {
    // var btnContainer = document.getElementById("tabs_menu");

    // // Get all buttons with class="btn" inside the container
    // var btns = btnContainer.getElementsByClassName("menu_item");

    // // Loop through the buttons and add the active class to the current/clicked button
    // for (var i = 0; i < btns.length; i++) {
    //   btns[i].addEventListener("click", function() {
    //     var current = document.getElementsByClassName("active");

    //     // If there's no active class
    //     if (current.length > 0) {
    //       current[0].className = current[0].className.replace(" active", "");
    //     }

    //     // Add the active class to the current/clicked button
    //     this.className += " active";
    //   });
    // }
    var btnContainer = document.getElementById('tabs_menu');

    // Get all buttons with class="btn" inside the container
    var btns = btnContainer.getElementsByClassName('menu_item');

    // Loop through the buttons and add the active class to the current/clicked button
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        var current = document.getElementsByClassName('active');
        console.log(current);

        current[0].className = current[0].className.replace(' active', '');
        this.className += ' active';
      });
    }
    document.getElementById('about').scrollIntoView({ behavior: 'smooth' });
  }
  openReviewsTab() {
    // var btnContainer = document.getElementById("tabs_menu");

    // // Get all buttons with class="btn" inside the container
    // var btns = btnContainer.getElementsByClassName("menu_item");

    // // Loop through the buttons and add the active class to the current/clicked button
    // for (var i = 0; i < btns.length; i++) {
    //   btns[i].addEventListener("click", function() {
    //     var current = document.getElementsByClassName("active");

    //     // If there's no active class
    //     if (current.length > 0) {
    //       current[0].className = current[0].className.replace(" active", "");
    //     }

    //     // Add the active class to the current/clicked button
    //     this.className += " active";
    //   });
    // }
    var btnContainer = document.getElementById('tabs_menu');

    // Get all buttons with class="btn" inside the container
    var btns = btnContainer.getElementsByClassName('menu_item');

    // Loop through the buttons and add the active class to the current/clicked button
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        var current = document.getElementsByClassName('active');
        console.log(current);
        current[0].className = current[0].className.replace(' active', '');
        this.className += ' active';
      });
    }
    document.getElementById('reviews').scrollIntoView({ behavior: 'smooth' });
  }
  // tabs end here
  getColors() {
    let symbols = '0123456789ABCDEF';

    let color = '#';
    for (var i = 0; i < 6; i++) {
      color = color + symbols[Math.floor(Math.random() * 16)];
    }
    this.Randomcolor = color;
    console.log(this.Randomcolor);
  }
  // showGallery() {
  //   this.navCtrl.push("GalleryPage", { gallaryData: this.nID });
  // }
  Reviews() {
    // this.navCtrl.push("ReviewsPage", { reviewData: this.nID });
    this.router.navigateByUrl('reviews', { state: { reviewData: this.nID } });
    this.globals.activeBusinessData = this.businessData;
    // console.log(reviewData)
  }
  async addReview() {
    let isLogin = localStorage.getItem('isLogin');
    if (isLogin == 'true') {
      let modal = await this.modalCtrl.create({
        component: AddReviewsPage,
        componentProps: {
          place: this.placeName,
          bID: this.reviewId,
          reviewData: undefined,
        },
        cssClass:'add_review_modal',
      });
      modal.onDidDismiss().then(() => {
        if(this.openReviewPage){
          this.openReviewPage=undefined;

        }
        this.reviewdata();
      });
      modal.present();
    } else {
      let alert = await this.alertCtrl.create({
        message: 'Login to use this feature',
        buttons: ['Ok'],
      });
      alert.present();
    }
  }
  async editReview(reviewdata) {
    console.log(reviewdata);
    let isLogin = localStorage.getItem('isLogin');
    if (isLogin == 'true') {
      let modal = await this.modalCtrl.create({
        component: AddReviewsPage,
        componentProps: {
          place: this.placeName,
          bID: this.reviewId,
          reviewData: reviewdata,
          editReview: 'true',
        },
      });
      modal.onDidDismiss().then(() => {
        this.reviewdata();
      });
      modal.present();
    } else {
      let alert = await this.alertCtrl.create({
        message: 'Login to use this feature',
        buttons: ['Ok'],
      });
      alert.present();
    }
  }
  saveAddress() {
    this.globals.address = this.autocomplete.query;
    this.addressSearch = false;
    this.autocompleteItems = [];
  }
  editAddress() {
    this.addressSearch = true;
  }
  dismiss() {
    this.temp = false;
    this.autocompleteItems = [];
  }
  //   loadBanner() {
  //     let response = this.server.LoadBannersOnHomePage()
  //     response.subscribe(data => {
  //         console.log(data)})

  //       }

  cancelAddressSearch() {
    this.addressSearch = false;
  }
  chooseItem(item: any) {
    this.autocomplete.query = item;
    this.geo = item;
    this.dismiss();
    this.geoCode(this.geo);
    console.log('item', item);
    console.log('geo', this.geo);
  }
  geoCode(address: any) {
    // let that = this;
    let geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: address }, (results, status) => {
      this.globals.mycoordinates =
        results[0].geometry.location.lat() +
        ',' +
        results[0].geometry.location.lng();
      // this.list();
    });
  }
  updateSearch() {
    console.log('search is on');
    console.log(this.autocompleteItems);
    console.log('length', this.autocomplete.query.length);

    if (this.autocomplete.query == '') {
      console.log('if run');
      this.autocompleteItems = [];
      this.temp = false;
      return;
    } else if (this.autocomplete.query.length >= 3) {
      console.log('else if run');
      this.temp = true;
      let me = this;
      this.service.getPlacePredictions(
        {
          input: this.autocomplete.query,
          componentRestrictions: {
            country: ["us", "ca"],
          },
        },
        (predictions, status) => {
          me.autocompleteItems = [];

          me.zone.run(() => {
            if (predictions != null) {
              predictions.forEach((prediction) => {
                me.autocompleteItems.push(prediction.description);
                console.log(me.autocompleteItems);
              });
            }
          });
        }
      );
    } else {
      console.log('else run');
    }
  }

  checkTiming(Timing) {
    if (Timing && Timing.length > 0) {
      var scheduled_time_ = localStorage.getItem('scheduled_time');
      var date: any;
      var time: any;
      var day: any;
      if (scheduled_time_ && scheduled_time_ != 'undefined') {
        day = this.s_day;
        time = this.s_time;
      } else {
        date = new Date();
        day = date.getDay();
        time = date.getHours() + '.' + date.getMinutes();
      }

      if (day == 7) {
        day = 0;
      }

      var current_day = Timing[day];
      var n = current_day[0].indexOf('.');
      if (n != -1) {
        var res = current_day[0].split('.');
        current_day[0] = res[0] + '.' + '3';
      }
      var n1 = current_day[1].indexOf('.');
      if (n1 != -1) {
        var res = current_day[1].split('.');
        current_day[1] = res[0] + '.' + '3';
      }

      time = Number(time);
      if (current_day) {
        if (
          (Number(current_day[0]) <= time && Number(current_day[1]) > time) ||
          (Number(current_day[0]) <= time &&
            Number(current_day[1]) < Number(current_day[0]))
        ) {
          return true;
        } else if (current_day[0] == 'opened' && current_day[1] == 'opened') {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  time_change() {
    var scheduled_time_ = localStorage.getItem('scheduled_time');
    if (scheduled_time_ && scheduled_time_ != 'undefined') {
      let response = this.server.date_convert(scheduled_time_);
      response.subscribe(
        (data) => {
          if (data.success == true) {
            this.s_day = data.day_id + 1;
            this.s_time = data.time;
          }

          var that = this;
          for (var i = 0; i < this.category.length; i++) {
            this.category[i].items = this.category[i].items.filter(function (
              item
            ) {
              return that.checkTiming(item.item_timings) == true;
            });
          }
        },
        (error) => {
          this.globals.presentToast(
            'Something went wrong check your internet connection.'
          );
        }
      );
    } else {
      var that = this;
      for (var i = 0; i < this.category.length; i++) {
        this.category[i].items = this.category[i].items.filter(function (item) {
          return that.checkTiming(item.item_timings) == true;
        });
      }
    }
  }

  getLocation() {
    let id
    this.globals.presentToast('Getting location...');
    this.geolocation.getCurrentPosition().then(
      (position) => {
        this.addressSearch = false;
        this.globals.mycoordinates =
          position.coords.latitude + ',' + position.coords.longitude;
        this.reverseGeoCoding();
       id = this.route.snapshot.params['name'];
        if (!this.globals.address) {
          this.list(id);
        }
      },
      async (err) => {
        let alert = await this.alertCtrl.create({
          header: this.globals.locationAlert_title,
          subHeader: this.globals.locationAlert_text,
          buttons: [
            {
              text: 'Cancel',
              handler: (data) => {
                if (!this.globals.address) {
                  this.list(id);
                }
                // this.list();
                // console.log('Cancel clicked');
              },
            },
            {
              text: 'OK',
              handler: (data) => {
                if (!this.globals.address) {
                  this.list(id);
                }
                // this.list();
                // console.log('Ok clicked');
              },
            },
          ],
        });

        alert.present();
        // console.log(err);
      }
    );
  }
  loadMap() {
    console.log(this.mapElement);

    let mapOptions = {
      center: {
        lat: this.latitude,
        lng: this.longitude,
      },
      fullscreenControlOptions: false,
      mapTypeControl: false,
      zoom: 15,
      streetViewControl: false,
      zoomControl: false,
      fullscreenControl: false,
      keyboardShortcuts: false,
      scrollwheel: false,
      scaleControl: false,
      draggable: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    console.log(this.latitude, this.longitude);
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    //  this.addMarker(position.coords.latitude,position.coords.longitude);
    this.addMarker(this.latitude, this.longitude);
  }
  // draggMarker(){
  //   this.map.one(google.MAP_READY)
  //               .then(() => {
  //                 console.log('Map is ready!');

  //                 this.map.addMarker({
  //                   title: 'Ionic',
  //                   icon: 'blue',
  //                   animation: 'DROP',
  //                   draggable:true,
  //                   position: {
  //                     lat: this.latitude,
  //                     lng: this.longitude
  //                   }
  //                 })
  //                 .then(marker => {
  //                   marker.on(google.MARKER_DRAG_END)
  //                     .subscribe(() => {
  //                       //position => lat long
  //                       // this.markerlatlong = marker.getPosition();

  //                       // localStorage.setItem("latt1",this.markerlatlong.lat);
  //                       // localStorage.setItem("long1",this.markerlatlong.lng);

  //                       this.http.get('API URL').map(res => res.json()).subscribe(data => {
  //                         console.log(data);
  //                       });

  //                     });
  //                 });

  //               });
  // }
  addMarker(lat: number, lng: number) {
    console.log('Marker Cords', lat, lng);
    let latLng = new google.maps.LatLng(lat, lng);
    let marker = new google.maps.Marker({
      map: this.map,
      animation: google.maps.Animation.DROP,
      position: latLng,
      icon: 'assets/imgs/locationIcon.png',
    });

    let content = this.businessData.name;

    this.addInfoWindow(marker, content);
  }
  addInfoWindow(marker, content) {
    let infoWindow = new google.maps.InfoWindow({
      content: content,
    });

    // google.maps.event.addListener(marker,google.maps.event.MARKER_DRAG_END, () => {
    google.maps.event.addListener(marker, 'click', () => {
      infoWindow.open(this.map, marker);
      // this.getMarkerPosition(marker.getPosition()); //for dragging marker
    });
  }
  // for dragging marker
  // getMarkerPosition(latlng){
  //   var geocoder = new google.maps.Geocoder();
  //   geocoder.geocode({latLng: latlng},(results, status)=> {
  //   let address= results[0].formatted_address;
  //   console.log('moved marker.. ',address)
  //   })

  //   }
  // for dragging marker

  list(id) {
    let response = this.server.getPlace(id);
    response.subscribe(
      (data) => {
        if (data.status == 'false') {
          this.navCtrl.navigateForward('not-found');

          return;
        }
        console.log('fromurl get places ', data);
        this.places = data.results;
        this.businessData = this.places[0];
        // if (this.businessData) {
        //   this.globals.setupBusiness(this.businessData);
        // }

        var new_id = this.globals.new_id;
        // this.places = this.places.filter(function (item) {
        //   return item.business_id === new_id;
        // });

        this.globals.business_name = this.places[0].name;
        this.globals.business_phone = this.places[0].phone;
        this.globals.business_address = this.places[0].address;
        this.globals.business_username = this.places[0].username;
        this.globals.estimated_time = this.places[0].delivery_time;
        this.discoveredBy=this.places[0].discovered_by;
        console.log(this.discoveredBy,'discovered by object');
        // this.globals.business_discount_count = parseInt(
        //   this.places[0].business_discount_count
        // );
        this.globals.username = this.places[0].username;
        this.globals.bussinessId = this.places[0].business_id;
        this.globals.admin_stripe = this.places[0].admin_stripe_enabled;
        this.globals.pickupsetting = this.places[0].delivery_time;
        this.globals.tax = this.places[0].tax;
        this.globals.deliveryCharges = this.places[0].delivery_fee;
        this.globals.tip_enabled = this.places[0].tip_enabled;
        this.globals.menu_ready = this.places[0].menu_ready;
        this.globals.pickup_Time = this.places[0].pickup_time;
        this.globals.minimun_order = parseInt(this.places[0].minimum_order);
        this.globals.StripId = this.places[0].stripe_id;
        // this.globals.availed_discount_count = parseInt(
        //   this.places[0].customer_discount_availed_count
        // );
        this.globals.paypalId = this.places[0].paypal_id;
        this.globals.Timing = this.places[0].hours_operation;
        this.globals.pickup = this.places[0].pickup;
        this.globals.menu_ready = this.places[0].menu_ready;

        if (this.globals.pickup == '1') {
          this.globals.pickup = true;
        } else {
          this.globals.pickup = false;
        }

        if (this.places[0].delivery == '1') {
          this.globals.delivery = true;
        } else {
          this.globals.delivery = false;
        }

        if (this.places[0].cash_enabled == '1') {
          this.globals.cash_enabled = true;
        } else {
          this.globals.cash_enabled = false;
        }
        this.globals.setupBusiness(this.businessData);
        this.pickupTime = this.globals.myDate;
        let temdate = localStorage.getItem('scheduled_time');
        if (temdate != null || temdate != '' || temdate != undefined) {
          this.pickupTime = temdate;
        }
        if (this.pickupTime != null) {
          if (this.pickupTime.length > 0) {
            this.pickupTime = this.pickupTime.replace('T', ' ');
            this.pickupTime = this.pickupTime.slice(0, 16);
          }
        }
        this.globals.Email = localStorage.getItem('userEmail');
        // setup business for usage in app - part of new halal guide app
        // console.log('nav businessdata',this.businessData)
        // console.log('business data ',this.businessData);

        // this.businessData = this.navParams.get("businessData");
        this.resAddress = this.businessData.address;
        this.isVerified = this.businessData.listing_verified;
        this.globals.bussinessId = this.businessData.business_id;
        // console.log('business id is', this.globals.bussinessId)
        this.reviewId = this.businessData.business_id;
        this.placeName = this.businessData.username;
        // console.log('hours op .... ',this.businessData.timings.hours_operation.hasOwnProperty(7))

        //if returning from external link
        // if (this.globals.activeBusinessData != undefined) {
        //   this.businessData = this.globals.activeBusinessData
        //   // this.globals.bussinessId = this.businessData.business_id;
        // }
        //ends here
        this.globals.activeBusinessData = this.businessData;

        this.name = this.businessData.name;
        let long = parseFloat(this.businessData.longitude);
        let lat = parseFloat(this.businessData.latitude);
        this.longitude = long;
        this.latitude = lat;
        console.log('entered in category page');
        if (this.businessData != undefined) {
          this.nID = this.businessData.business_id;
        }

        if (this.newId != undefined) {
          this.nID = this.newId;
        }
        console.log(this.businessData);
        // if (this.businessData) {
        //   this.globals.setupBusiness(this.businessData);
        // }

        if (!this.globals.caos_flag) {
          console.log('Modal call from category');

          if (this.businessData.delivery == '1') {
            console.log('pick and delivery check  ');
            this.globals.OrderType = 'delivery';
            // this.presentModal(0);
          }
        } else {
          this.globals.OrderType = 'pickup';
          console.log('Order type is -> ', this.globals.OrderType);
        }

        // this.cartflag = this.navParams.get("CartFlag");
        // this.PageFlag = this.navParams.get("pageflag");
        this.business_id = this.globals.bussinessId;

        if (!this.globals.caos_flag) {
          // this.getLocation();
        }

        this.myChoice.push('abcd');
        this.myChoice.pop();

        this.globals.title = this.globals.category_name;
        // new
        //  this.Categories();
        // new

        // this.getType();
        this.getColors();
        this.openAboutTab();
        this.getFavorites();
        this.reviewdata();
        this.cuisinesOfThisBusiness();
        this.loadMap();

        this.Categories();
        if(this.openReviewPage){
          this.addReview();
        }
      },
      (error) => {
        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
  }

  historypage() {
    // this.navCtrl.push("OrderListingPage");
  }
   async showBusinesses(user){
    let modal =await this.modalCtrl.create({
      component:MyBusinessesPage,
      componentProps:{ udid: user.udid,
      first_name:user.first_name,
    last_name:user.last_name},
     

    })
    modal.present();
    modal.onDidDismiss().then(res=>{
      console.log(res)
    })

  }
  async presentModal(type) {
    console.log('model called from category page');
    if (type == 1) {
      let modal = await this.modalCtrl.create({
        component: OrderSettingsPage,
      });
      modal.onDidDismiss().then((data) => {
        console.log(data);
        if (data.data.date != null || data.data.date != undefined) {
          this.globals.myDate = data.data.date;
          this.pickupTime = this.globals.myDate;
          this.pickupTime = this.pickupTime.replace('T', ' ');
          this.pickupTime = this.pickupTime.slice(0, 16);
          this.openMenu(this.businessData, 'schedule');
        }
        console.log('data returned from model.=> ', data);
        this.Categories();
      });
      modal.present();
    } else {
      if (this.globals.model_flag) {
        this.globals.model_flag = false;
        let modal = await this.modalCtrl.create({
          component: OrderSettingsPage,
        });
        modal.onDidDismiss().then((data) => {
          console.log('data returned from model.2=> ', data);
          if (data.data.date != null || data.data.date != undefined) {
            this.pickupTime = this.globals.myDate = data.data.date;
            this.pickupTime = this.globals.myDate;
            this.pickupTime = this.pickupTime.replace('T', ' ');
            this.pickupTime = this.pickupTime.slice(0, 16);
          }
          var orderSchedule = localStorage.getItem('scheduled_time');
          if (
            orderSchedule == undefined ||
            orderSchedule == 'undefined' ||
            (this.globals.OrderType == 'delivery' &&
              (this.globals.inradius == false || this.globals.address == ''))
          ) {
            this.globals.model_flag = true;
            this.navCtrl.navigateRoot('home');
            // this.router.
          }
        });
        modal.present();
      }
    }
  }
  navigateTo() {
        console.log('navigate')
    // let coords=[this.latitude,this.longitude];
    // console.log('coords .... ',coords)
    // return;
    // this.launchNavigator.appSelection
    let rememberChoice: RememberChoiceOptions = {
      enabled: false,
    };
    let appSelection: AppSelectionOptions = {
      list: [
        this.launchNavigator.APP.GOOGLE_MAPS,
        this.launchNavigator.APP.WAZE,
        this.launchNavigator.APP.APPLE_MAPS,
        this.launchNavigator.APP.YANDEX,
        this.launchNavigator.APP.CITYMAPPER,
      ],
      rememberChoice: rememberChoice,
    };

    let options: LaunchNavigatorOptions = {
      // start: this.globals.address,
      appSelection: appSelection,
    };
    if (this.businessData.address) {
      this.launchNavigator.navigate(this.businessData.address, options).then(
        (success) => {
          // this.launchNavigator.appSelection.userChoice.clear(()=>{
          //   console.log("User preferred app is cleared");
          // });
          console.log(success, 'Launched navigator');
        },
        (error) => {
          //   this.launchNavigator.appSelection.userChoice.clear(()=>{
          //     console.log("User preferred app is cleared");
          // });
          let link="https://www.google.com/maps?q="+this.businessData.address;
          // dfghjk
          // this.aib.create(link);
          window.open(link, '_blank').focus();
          // this.globals.presentToast('Failed to navigate');
          console.log('Error launching navigator', error);
        }
      );
    }
    else{
      this.globals.presentToast("Address is not valid.")
    }
    // this will clear user selection..... will add to settings later.
  }
  async openUsersReviews(user) {
    let modal = await this.modalCtrl.create({
      component: ShowUserReviewsPage,
      componentProps: { data: { user: user } },
    });
    modal.onDidDismiss().then((data) => {
      if (data.data != null || data.data != undefined) {
      }
      console.log('usermodal says.=> ', data.data);
    });
    modal.present();
  }

  ionViewDidLoad() {
    // let url=window.location.href
    // console.log('url of page',url)
    this.globals.showbackButton = true;
  }

  Cart(object, flag, id, image, freeextras) {
    if (
      this.globals.BusinessID == '-1' ||
      this.globals.BusinessID == this.business_id
    ) {
      this.globals.BusinessID = this.business_id;
      this.AddtoCart(object, flag, id, image, freeextras);
    } else {
      this.showPrompt(object, flag, id, image, freeextras);
    }
  }

  async showPrompt(object, flag, id, image, freeextras) {
    let prompt = await this.alertCtrl.create({
      header: 'Alert',
      message:
        'Are you sure you want to switch Restaurant? This will clear your current cart.',

      buttons: [
        {
          text: 'Cancel',
          handler: (data) => {
            console.log('Cancel clicked');
          },
        },
        {
          text: 'Okay',
          handler: (data) => {
            this.globals.Product.length = 0;
            this.globals.BusinessID = this.business_id;
            this.AddtoCart(object, flag, id, image, freeextras);
          },
        },
      ],
    });
    prompt.present();
  }

  toggleGroup(group) {
    if (this.isGroupShown(group)) {
      this.shownGroup = null;
    } else {
      this.shownGroup = group;
    }
  }
  floated(x) {
    return Number.parseFloat(x).toFixed(1);
  }
  // round(x){
  //   // console.log('rating is ....',Math.round(Number(x)))
  //  let y=Math.round(Number(x))
  //  console.log(y)
  //   return y
  // }
  string(x) {
    return String(x);
  }
  isGroupShown(group) {
    return this.shownGroup === group;
  }
  // getCuicinesList(){
  //   this.server.getCuicines()
  // }
  async Categories() {
    // let loading = this.loadingCtrl.create({
    //   content: "Loading...",
    // });
    // loading.present();
    const toast = await this.toastCtrl.create({
      message: 'Please wait..',
      color: 'primary',
      mode: 'ios',
    });
    toast.present();
    let response = this.server.GetBusinessMenuCategories(
      this.globals.bussinessId
    );
    response.subscribe(
      (data) => {
        this.dataNotLoaded = false;

        toast.dismiss();

        this.data = data;
        console.log('cat', data);
        // if(this.data)
        this.promotedItems = data.promoted_items;
        // loading.dismiss();
        this.category = this.data.categories;
        // this.Topitem1 = this.category[0].items[0]
        // console.log('item at zero index',this.Topitem1)
        // this.Topitem2 = this.category[1].items[1]
        // // console.log('top items',this.categoryTop)
        this.super_category = this.data.super_categories;
        if (this.super_category.length == 1) {
          this.categoryClicked(this.super_category[0]);
        }
        this.name = this.data.restaurant.name;
        this.globals.title = this.name;
        this.globals.category_name = this.name;

        this.super_category.forEach((element) => {
          if (element.priority == 1) {
            this.categories_section = element.name;
          }
        });

        this.data.categories.forEach((element) => {
          element.items.forEach((subelement) => {
            subelement.quantity = 1;
          });
        });

        this.time_change();
        this.forsearch = this.category;
        if (this.data.categories.length == 0) {
          this.DataFlag = true;
        }
        if (this.isOpenMenu) {
          // sdf
          this.openMenu(this.businessData, 'now');
        }
      },
      (error) => {
        toast.dismiss();

        // loading.dismiss();
        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
  }

  segmentChanged($event) {}

  categoryClicked(item) {
    this.categories_section = item.name;

    // let loading = this.loadingCtrl.create({
    //   content: "Loading...",
    // });
    // loading.present();
    // const toast = this.toastCtrl.create({
    //   message: 'Please wait..',
    //   duration: 500,
    // })
    // toast.present();

    let response = this.server.GetSuperCategories(
      this.globals.bussinessId,
      item.id
    );
    response.subscribe(
      (data) => {
        console.log('get super categories', data);
        // loading.dismiss();
        if (data.categories.length == 0) {
          this.DataFlag = true;
          this.category = data.categories;
        } else {
          this.category = data.categories;
          data.categories.forEach((element) => {
            element.items.forEach((subelement) => {
              subelement.quantity = 1;
            });
          });
          this.time_change();
          this.forsearch = this.category;
        }
      },
      (error) => {
        // loading.dismiss();
        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
  }
  // ghjhkjl..hjj
  Detail($event, list, id, image, freeextras, type) {
    this.globals.itemDetail = list;
    this.globals.dataNotLoaded = true;
    console.log(list);

    // this.navCtrl.push("ItemDetailPage", {
    //   type: type,
    //   item_id: id,
    //   image: image,
    //   BusinesId: this.business_id,
    //   free_extras: freeextras,
    //   business:this.businessData,
    // });
    this.router.navigateByUrl('item-details', {
      state: {
        type: type,
        item_id: id,
        image: image,
        BusinesId: this.business_id,
        free_extras: freeextras,
        business: this.businessData,
      },
    });
  }

  // OpenSettingPage() {
  //   this.navCtrl.push("SettingsPage");

  // }

  AddtoCart(object, flag, id, image, freeextras) {
    this.cartObjectQuantity = 1;
    this.subtotal = object.price * object.quantity;
    if (this.globals.Product.length > 0) {
      this.globals.cartflag = true;
      this.globals.Product.forEach((element) => {
        if (!this.isexist) {
          if (element.menuItem == object.name) {
            this.index = this.globals.Product.indexOf(element);
            this.isexist = true;
          } else {
            this.isexist = false;
          }
        }
      });

      if (this.isexist) {
        if (flag == true) {
          object.quantity += 1;
          this.globals.Product[this.index].quantity =
            this.cartObjectQuantity +
            Number(this.globals.Product[this.index].quantity);
          this.toastPresent('Item is successfully added to cart');
        } else {
          object.quantity = this.removeQuantity(object);
          if (this.globals.Product[this.index].quantity != 1) {
            this.globals.Product[this.index].quantity =
              Number(this.globals.Product[this.index].quantity) -
              this.cartObjectQuantity;
            this.toastPresent('Item is successfully removed from the cart');
          }
        }

        this.globals.Product[this.index].totalPrice =
          Number(object.price) * this.globals.Product[this.index].quantity;
        this.globals.Product[this.index].totalPrice = parseFloat(
          this.globals.Product[this.index].totalPrice
        ).toFixed(2);

        this.isexist = false;
      } else {
        this.globals.Product.push({
          menuId: '1',
          restId: this.globals.bussinessId,
          uniqueId: id,
          menuItem: object.name,
          image: object.image,
          quantity: object.quantity,
          basePrice: Number(object.price),
          totalPrice: Number(this.subtotal),
          menuExtrasSelected: this.myChoice,
        });
        this.toastPresent('Item is successfully added to cart');
      }
    } else {
      if (flag == true) {
        this.globals.Product.push({
          menuId: '1',
          restId: this.globals.bussinessId,
          uniqueId: id,
          menuItem: object.name,
          image: object.image,
          quantity: object.quantity,
          basePrice: Number(object.price),
          totalPrice: this.subtotal,
          menuExtrasSelected: this.myChoice,
        });
        this.toastPresent('Item is successfully added to cart');
        this.globals.cartflag = true;
      }
    }
    this.Savecart();
  }

  Savecart() {
    this.nativeStorage
      .setItem('Product', {
        array: this.globals.Product,
        businessDiscount: this.globals.BusinessDiscount,
        BusinessID: this.globals.BusinessID,
      })
      .then(
        () => console.log('Stored item!'),
        (error) => console.error('Error storing item', error)
      );
  }

  addQuantity(object) {
    object.quantity += 1;
  }

  removeQuantity(object) {
    if (object.quantity <= 1) {
      object.quantity = 1;
    } else {
      object.quantity -= 1;
    }
    return object.quantity;
  }

  async toastPresent(Message) {
    let toast = await this.toastCtrl.create({
      message: Message,
      duration: 2000,
      position: 'bottom',
      color: 'primary',
    });
    toast.present();
  }
  getFavorites() {
    let res = JSON.parse(localStorage.getItem('myFavorites'));
    console.log(res);
    if (res != null) {
      this.myFavorites = res;
      console.log('My fav', this.myFavorites);
      this.myFavorites.forEach((element) => {
        const newArray = Object.values(element);
        if (newArray.includes(this.businessData.name)) {
          this.isFavorite = true;
        }
      });
    }
  }
  async addToFavorite(business) {
    let islogin = localStorage.getItem('isLogin');
    if (islogin == 'true') {
      console.log('yes user is logged in,can add to fav');
      if (this.myFavorites.length == 0) {
        console.log('first item to fav');
        this.isFavorite = true;
        this.myFavorites.push(business);
        localStorage.setItem('myFavorites', JSON.stringify(this.myFavorites));
        this.toastPresent(business.name + ' Added to favorites');
      } else {
        console.log('checking if already in fav');
        this.myFavorites.map((element) => {
          // console.log(element)
          const newArray = Object.values(element);
          // console.log(newArray)
          if (newArray.includes(business.name)) {
            this.inFavList = true;
            // this.toastPresent("Already in favorites");
          } else {
            // console.log('not in fav list. adding to list')
            // this.isFavorite = true;
            // this.myFavorites.push(business)
            // localStorage.setItem('myFavorites', JSON.stringify(this.myFavorites));
            // this.toastPresent(business.name + " Added to favorites");
          }
        });
        if (this.inFavList == true) {
          console.log('already in fav list');
          this.toastPresent('Already in favorites');
        } else {
          console.log('not in fav list. adding to list');
          this.isFavorite = true;
          this.myFavorites.push(business);
          localStorage.setItem('myFavorites', JSON.stringify(this.myFavorites));
          this.toastPresent(business.name + ' Added to favorites');
        }
      } //end of else
      // this.myFavorites.forEach(element =>{

      //   console.log(element)
      //   if(element==business){
      //     console.log('exist')
      //   }
      //   else{
      //     console.log("not exist")
      //   }

      // } )
      // if(this.myFavorites.includes(business)){
      //   console.log('exists')
      // }
      // else{
      //   console.log('not exists')

      // }
      //   if(this.myFavorites.indexOf(business.id) !== -1){
      //     console.log("Value exists!")
      // } else{
      // console.log("Value does not exists!")
      // this.myFavorites.push(business)
      // localStorage.setItem('myFavorites',JSON.stringify(this.myFavorites));
      // this.toastPresent("added to favorites");
      // }
    } else {
      let alert = await this.alertCtrl.create({
        message:
          'Not logged in . login now to save your favorite restaurant/shop',
        buttons: [
          {
            text: 'Later',
            cssClass: 'cancel_btn',
            handler: (data) => {
              console.log('Cancel clicked');
            },
          },
          {
            text: 'Login now',
            handler: (data) => {
              // this.navCtrl.push('LoginPage')
              this.navCtrl.navigateForward('login');
            },
          },
        ],
      });
      alert.present();
    }
  }
  async cartpage() {
    if (this.globals.Product.length == 0) {
      let alert = await this.alertCtrl.create({
        header: 'Empty cart',
        message: 'Hungry? order some food now',
        buttons: ['Okay'],
      });
      alert.present();
    } else {
      this.navCtrl
        .navigateForward('cart', {})
        .then(
          (response) => {
            console.log('Response ' + response);
          },
          (error) => {
            console.log('Error: ' + error);
          }
        )
        .catch((exception) => {
          console.log('Exception ' + exception);
        });
    }
  }

  click(d, event) {
    console.log(d);
    this.globals.menu_id = d.category_id;
  }

  searchnew() {
    let val = this.keyword;
    if (val) {
      if (val && val.trim() != '') {
        this.category = this.forsearch;
        this.category = this.category.filter((item) => {
          return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1;
        });
      }
    } else {
      this.category = this.forsearch;
    }
  }

  onCancel(e) {
    this.category = this.forsearch;
  }
  reviewdata() {
    let response = this.server.BusinessInformation(
      this.businessData.business_id,
      this.businessData.username,
      this.globals.udid
    );
    console.log(this.businessData.business_id, this.businessData.username);
    // let loading = this.loadingCtrl.create({
    //     content: "Loading...",
    // });
    // loading.present();
    // const toast = this.toastCtrl.create({
    //   message: 'Please wait..',
    //   duration: 500,
    // })
    // toast.present();

    response.subscribe(
      (data) => {
        this.data = data;
        console.log('reviews data', data);
        // this.info=data.info;
        // loading.dismiss();
        this.averageRating = this.data.average_rating;
        this.details = this.data;

        // this.name = this.details.info.name;
        this.reviewData = this.details.reviews;
        // for limited reviews on this screen.. below condition
        if (this.reviewData.length > 10) {
          this.reviewData = this.reviewData.slice(0, 10);
          console.log('sliced array is ', this.reviewData);
        }

        // this.length = this.reviewData.length
      },
      async (error) => {
        // loading.dismiss();
        let alert = await this.alertCtrl.create({
          header: 'Error',
          subHeader: 'Server times out,please try again',
          buttons: ['OK'],
        });
        alert.present();
      }
    );
  }
  async socialSharePage() {
    let sharingUrl= window.location.href;
    let currentUrl = window.location.hostname;
    console.log(currentUrl,sharingUrl);
    //change Weburl if changing domain.
// this.businessData.name +' is now available at The Halal Guide.'

    if (currentUrl!='localhost') {
      const alert = await this.alertCtrl.create({
        // message: 'This feature is for App only, but you can copy link and share',

        message: this.capitalize(this.businessData.name) +' Is Now Available at Halal Guide.',
        buttons: [
          {
            text: 'Copy link and share',
            cssClass: 'share_alert',
            handler: () => {
              navigator.clipboard.writeText(sharingUrl);
              this.globals.presentToast('Link copied',1000,'middle','success');
              console.log('Cancel clicked');
            },
          },
          // {
          //   text: 'Download app',
          //   handler: () => {
          //     window.open('http://halalguide.app.link/jYA2rkA33kb');
          //   },
          // },
        ],
        backdropDismiss:true,
      });
      alert.present();
    }
    // console.log(this.platform.platforms())
    //     var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    // if (isMobile) {
    //   console.log('mobile browser.......')
    // }
    //   if((this.platform.is('mobileweb')) || this.platform.is('browser') ||  this.platform.is('core') ){
    //     console.log('web platform...')

    // }if(this.platform.is('android') || this.platform.is('ios'))
    else {
      this.shareAll();
      // let link= 'thehalalguide://'+ this.route.snapshot.params['item']+'/'+ this.route.snapshot.params['name'];
      // navigator.clipboard.writeText(link);
      // this.globals.presentToast('Link copied',1000,'middle','success');
      // console.log('Cancel clicked');
      console.log('The platform is not web so genURL');
      // let properties = {
      //   canonicalIdentifier: '#/category',
      //   canonicalUrl: 'https://demo.mikronexus.net/#/category',
      //   contentMetadata: {
      //     business: this.businessData,
      //   }
      // }
      // this.branch.createBranchUniversalObject(properties).then((res) => {  //create universal object
      //   this.branchUniversalObj = res
      //   console.log('createing object for url Response: ' + JSON.stringify(res))
      //   this.generateLINK()
      // }).catch((err) => {
      //   console.log('Error: ' + JSON.stringify(err))
      // });
    }
    // else{
    //   console.log('not on cordova platform so plugin will not work')
    // }
  }
  capitalize(s){
    return s.toLowerCase().replace( /\b./g, function(a){ return a.toUpperCase(); } );
};
  shareAll() {
    let title = "Halal Guide";
let msg=this.capitalize(this.businessData.name) +' Is Now Available at '+title+'.'

    this.globals.bussinessId = this.businessData.business_id;
    // console.log('showing this businness=> ', business);
    let name = this.businessData.name + '-' + this.businessData.address;
    console.log(this.businessData.name, this.businessData.address);
    name = name.replace(/[^a-zA-Z ]/g, '');
    name = name.replace(/ /g, '-');
    name = name.replace(/--/g, '-');
    // value=value.replace(/,/g,'')

    this.ShareLinkURL="https://"+this.globals.webURL+'/'+name + '/' + this.businessData.business_id,
    // this.socialShare.canShareVia
    // net.thehalalguide.app://thehalalguide.com
    // let B_link='http://halalguide.app.link/jYA2rkA33kb';
    // let simpleAppURL='http://halalguide.app.link/jYA2rkA33kb';
    // if(this.platform.is('browser') || this.platform.is('mobileweb')){
    // }
    this.socialShare.share(msg, title, null, this.ShareLinkURL).then(res => {
      console.log('share via all', res)
    }).catch(err => { console.log(err) })
  }
  // generateLINK() {
  //   var analytics = {}
  //   var properties = {
  //     // $desktop_url: 'https://play.google.com/store/apps/details?id=net.thehalalguide.app',
  //     // $android_url: 'https://play.google.com/store/apps/details?id=net.thehalalguide.app',
  //     businessPage: true,
  //   }
  //   this.branchUniversalObj.generateShortUrl(analytics, properties).then((res) => {
  //     console.log(res)
  //     console.log('url genrate Response: ' + JSON.stringify(res.url))
  //     this.ShareLinkURL = res.url
  //     this.shareAll();
  //   }).catch((err) => {
  //     console.log('Error: ' + JSON.stringify(err))
  //   })
  // }
  callToNumber(phone){

      
      if(phone){
      this.callTo.callNumber(phone,false).then(res=>{
        console.log('call number response ',res)
      }).catch(err=>console.log('number not valid or something not good',err))
      }
  }
  // async startVerifying(){

  //   const alert = await this.alertCtrl.create({
  //     message: "Are you sure to claim this business's ownership",
  //     buttons: [
  //       {
  //         text: 'Cancel',
  //         role: 'cancel',
  //         cssClass: 'cancel',
  //         handler: () => {
  //           console.log('Confirm Cancel: blah');
  //         }
  //       }, {
  //         text: 'Claim',
  //         handler: () => {
  //           this.server.verifyBusinessCheck(this.globals.bussinessId).subscribe(res=>{

  //             console.log(res)
  //             if(res.success){

  //               this.globals.presentToast("Verification code sent..");
  //               //push  verification page
  //               let modal = this.modalCtrl.create("VerifyBusinessOtpPage",{businessId:this.globals.bussinessId});
  //               modal.onDidDismiss((data) => {
  //                 console.log('verified=>',data)
  //                 if(data.verified==true){
  //                   this.isVerified=data.verified;

  //                 }

  //               })
  //               modal.present();

  //               }
  //               else{
  //               this.globals.presentToast("Failed to verify");

  //               }

  //           },err=>{
  //             this.globals.presentToast("Network error");

  //           })
  //           console.log('Confirm Okay');
  //         }
  //       }
  //     ]
  //   });

  //   await alert.present();

  // }
  async reportClosed() {
    let islogin = localStorage.getItem('isLogin');
    let udid = localStorage.getItem('udid');
    console.log(udid);
    if (islogin == 'true') {
      let alert = await this.alertCtrl.create({
        subHeader: 'Report Closed Business',
        message:
          'You are about to report this business as permanently closed , are you sure about this?',
        buttons: [
          {
            text: 'Cancel',
            handler: (data) => {
              // console.log("Cancel clicked");
            },
          },
          {
            text: 'Yes Report',
            handler: (data) => {
              // console.log("Ok clicked");
              this.reportClosedBusiness(udid, this.businessData.business_id);
            },
          },
        ],
      });
      alert.present();
      // console.log('yes user is logged in,can add to fav');
    } else {
      let alert = await this.alertCtrl.create({
        message: 'Not logged in. You need to login to report this business',
        buttons: [
          {
            text: 'Later',
            cssClass: 'cancel_btn',
            handler: (data) => {
              console.log('Cancel clicked');
            },
          },
          {
            text: 'Login now',
            handler: (data) => {
              // this.navCtrl.push('LoginPage')
              this.navCtrl.navigateForward('login');
            },
          },
        ],
      });
      alert.present();
    }
  }
  async reportClosedBusiness(udid, bid) {
    let toast = await this.toastCtrl.create({
      message: 'Reporting as Closed. Please wait..',
    });
    toast.present();
    this.server.reportBusiness(bid, udid).subscribe(
      async (res) => {
        toast.dismiss();
        console.log('reporting for close res ', res);
        if (res.status) {
          let toast = await this.toastCtrl.create({
            message:
              "You've reported " +
              this.businessData.name +
              "as permanently closed. we'll verify it for you. Thank you for your contribution",

            // showCloseButton:true,
            duration: 4000,
          });
          toast.present();
        } else {
          this.globals.presentToast('Failed to report, try again later');
        }
      },
      (err) => {
        toast.dismiss();

        this.globals.presentToast('Network error');
      }
    );
  }
  cuisinesOfThisBusiness() {
    this.server.getCuisinesOfBusiness(this.business_id).subscribe(
      (res) => {
        if (res.status) {
          // if()
          let temparray = res.data;
          this.cuisinesOfBusiness = temparray;
        }
        console.log('cuisines are', res);
      },
      (err) => {
        this.globals.presentToast('Network error');
      }
    );
  }
  async openImage(image) {
    let modal = await this.modalCtrl.create({
      component: PhotoViewerPage,
      componentProps: { image: image },
    });
    modal.present();

    // var options = {
    //   share: true, // default is false
    //   closeButton: true, // iOS only: default is true
    //   copyToReference: true // iOS only: default is false
    // };

    // if (this.platform.is("ios")) {
    //   image = decodeURIComponent(image);
    // }

    // this.photoViewer.show(image, "Review image", options);

    // this.photoViewer.show(image);
    // th
  }
  // emailverify(){

  // }
  async openMenu(businessData, type) {
    if (businessData.delivery == '1') {
      this.globals.OrderType = 'delivery';
    }
    if (type == 'now') {
      this.globals.order_time = 'now';
      this.globals.myDate = undefined;
      localStorage.setItem('scheduled_time', undefined);
    }

    console.log(businessData);
    let modal = await this.modalCtrl.create({
      component: MenuPage,
      componentProps: {
        businessData: this.businessData,
        business_id: this.business_id,
      },
      cssClass: 'menuModal',
    });

    modal.present();
    modal.onDidDismiss().then((res) => {
      console.log(this.globals.OrderType);
    });
  }
  toggleHours() {
    if (this.showhours) {
      this.showhours = false;
    } else {
      this.showhours = true;
    }
  }
  scheduleOrder() {}
}
